export const NotFoundIcon = () => (
    <svg width="110" height="110" fill="none" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" fill="#f0f4f8" />
        <path d="M8.5 9.5l7 7M15.5 9.5l-7 7" stroke="#2b97be" strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="12" cy="12" r="9" stroke="#e3e6ed" strokeWidth="2" />
    </svg>
);